module.exports = "/_next/static/images/peter-4f9819ea486177d9fce9fe2e2fd33690.png";